export const formatAsMoney = ({
  value,
  type = "short",
  hideCurrency = false,
  currency = "NGN",
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
}) => {
  if (value === undefined || value === null) {
    return "";
  }

  return new Intl.NumberFormat("en-NG", {
    ...(hideCurrency ? {} : { style: "currency", currency, type }),
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
};
